export default __webpack_public_path__ + "static/media/lv-collection_mobile.c30c98b7.png";